import React, { forwardRef, useMemo } from "react";
import { FieldError } from "react-hook-form";
import classNames from "classnames";

import { IInputField } from "types";
import { FormLabel } from "components";
import { debounce } from "lodash-es";

const CHANGE_DEBOUNCE = 500;

interface InputFieldProps extends IInputField {
  error?: FieldError | null;
}
export const InputField = forwardRef<
  HTMLInputElement,
  InputFieldProps & React.InputHTMLAttributes<HTMLInputElement>
>(({ name, label, type, error, required, onChange, ...rest }, ref) => {
  const debouncedOnChange = useMemo(
    () => debounce((data) => onChange && onChange(data), CHANGE_DEBOUNCE),
    [onChange]
  );

  return (
    <div className="field field--input">
      <label className="field__label" htmlFor={name}>
        <FormLabel label={label} required={required} />
        <input
          ref={ref}
          className={classNames(`form-${type}`, [error?.message && "is-error"])}
          id={name}
          name={name}
          type={type}
          aria-required={required} // add as aria attribute to disable HTML5 validation
          autoComplete={type}
          onChange={debouncedOnChange}
          {...rest}
        />
      </label>
      {error?.message && (
        <span className="form-message is-error is-animated" role="alert">
          {error?.message}
        </span>
      )}
    </div>
  );
});
